/** Linux客户端内核驱动相关功能开关 https://x10x5w53g2.feishu.cn/docx/doxcnUXIBLy3feYNn94eVqoLold */
export const LinuxDriverSwitch = {
  /** 网络功能开关 */
  network: false,
  /** 网络功能关闭提示语 */
  networkCloseTip: 'Linux客户端内核驱动暂不支持网络功能',
  /** Linux USB功能开关 */
  usb: false,
}

/** 域名访问限制触发策略临时开关 */
export const ACCESS_RESTRICTION_TRIGGER_STRATEGY_SWITCH = false
